import React, { useState } from "react";
import { CardText } from "material-ui/Card";
import { List, ListItem } from "material-ui/List";
import Avatar from "material-ui/Avatar";
import md5 from "js-md5";
import moment from "moment";
import FlatButton from "material-ui/FlatButton";
import NextIcon from "material-ui/svg-icons/navigation/chevron-right";
import PrevIcon from "material-ui/svg-icons/navigation/chevron-left";
import LinearProgress from "material-ui/LinearProgress";
import { makeTitle } from "../reducer";
import useSearchResponses from '../hooks/useSearchResponses';
import TextField from 'material-ui/TextField';
import DeleteIcon from 'material-ui/svg-icons/action/delete';


const SearchResponseList = ({ onClick, limit=12, userEmail, onDeleteClick }) => {
  const [ textValue, setTextValue ] = useState("");
  const [ performSearchTerm, setPerformSearchTerm ] = useState("")
  const { responses, fetching, min, max, hasMore, onNext, onPrevious } = useSearchResponses(limit, textValue, performSearchTerm);

  const handleClear = () => {
    setTextValue("");
    setPerformSearchTerm("");
  }

  return (
    <div style={{padding:16}}>
      <TextField
        value={textValue}
        onChange={e => setTextValue(e.target.value)}
        hintText="Enter full email (case sensitive)"
        floatingLabelText="Email Search"
        floatingLabelFixed={true}
      />
      <FlatButton
        label="Search"
        primary={false}
        onClick={() => setPerformSearchTerm(textValue)}
      />
      <FlatButton
        label="Clear"
        primary={false}
        onClick={handleClear}
      />
      {responses != null ? <CardText style={{ textAlign: "center" }}>
        <FlatButton
          disabled={min <= 1 || fetching}
          icon={<PrevIcon />}
          labelPosition="after"
          onClick={onPrevious}
          label="Newer"
        />
        &nbsp; Showing {min} - {max} &nbsp;
        <FlatButton
          labelPosition="before"
          onClick={onNext}
          disabled={!hasMore || fetching}
          label="Older"
          icon={<NextIcon />}
        />
      </CardText> : null}
      {fetching ? <LinearProgress mode="indeterminate" /> : null}
      <List>
        {responses != null ? responses.map(response => {
          let numSectionsComplete = [
            "monitoring",
            "assessment",
            "controlRules"
          ].reduce((count, section) => {
            if (response.metadata.completedSections[section]) {
              count++;
            }
            return count;
          }, 0);
          return (
            <ListItem
              onClick={() => onClick(response)}
              leftAvatar={
                <Avatar
                  src={`https://www.gravatar.com/avatar/${md5(
                    response.email
                  )}?d=mm`}
                />
              }
              key={response.metadata.id}
              primaryText={response.name}
              secondaryText={
                <span>
                  {`${makeTitle(response)}`}
                  <em>{response.context ? ` - ${response.context}` : ""}</em>
                </span>
              }
              rightIcon={
                <div style={{width: "auto", color: "grey", fontWeight: "lighter"}}>
                  <span>
                    {moment(response.metadata.createdAt).fromNow()}
                  </span>
                  {response.email === userEmail ? <DeleteIcon onClick={onDeleteClick.bind(this, response)}/> : null}
                </div>
              }
            />
          );
        }) : null }
      </List>
    </div>
  );
};

export default SearchResponseList;
